import moment from "moment";
import { lerp } from "./solvers.ts";
import { CallPriceDefault } from "../constants";
import days360, { US_NASD } from "days360";

export function convertPercentageStringToNumber(s) {
  s.replace(/\d+% ?/g, "");
  return Number(s) / 100;
}

export function calcYTM(
  maturityDate,
  deliveryDate,
  rate,
  pr,
  ytc
) {
  const settlement = deliveryDate;
  const redemption = CallPriceDefault;
  const freq = 2;

  let periodStart = getPeriodStart(settlement, maturityDate);
  let periodEnd = moment(periodStart).add(6, "month");

  const N = customDays360(periodEnd, maturityDate) / 180 + 1;
  let yld;
  if (N === 1) {
    const rateOverFreq = rate / freq;
    const E = 360 / freq;
    const A = customDays360(periodStart, settlement);
    const DSR = E - A;
    const mod = pr / 100 + (A / E) * rateOverFreq;

    yld = redemption / 100 + rateOverFreq - mod;
    yld *= (E * freq) / (DSR * mod);
  } else {
    yld = lerp(
      (x) => {
        return calcPrice(maturityDate, deliveryDate, rate, x);
      },
      pr,
      ytc,
      ytc * 1.1,
      0.0001
    );
  }
  return round(yld, 4);
}

export function calcPrice(
  maturityDate,
  deliveryDate,
  rate,
  yld
) {
  if (round(rate, 4) === round(yld, 4)) return 100.0;

  const settlement = deliveryDate;
  const redemption = CallPriceDefault;
  const freq = 2;

  let periodStart = getPeriodStart(settlement, maturityDate);
  let periodEnd = moment(periodStart).add(6, "month");

  const N = customDays360(periodEnd, maturityDate) / 180 + 1;
  const E = 360 / freq;
  const A = customDays360(periodStart, settlement);
  const yldOverFreq = yld / freq;
  const rateOverFreq = rate / freq;

  let price = 0.0;
  if (N > 1) {
    const DSC = customDays360(settlement, periodEnd);
    const expMod = DSC / E;
    price += redemption / Math.pow(yldOverFreq + 1, N - 1 + expMod);
    for (let k = 1; N >= k; k++) {
      price += (rateOverFreq * 100) / Math.pow(yldOverFreq + 1, expMod + k - 1);
    }
    price -= (rateOverFreq * A * 100) / E;
  } else {
    const DSR = E - A;
    const T1 = rateOverFreq * 100 + redemption;
    const T2 = (yldOverFreq * DSR) / E + 1;
    const T3 = (rateOverFreq * A * 100) / E;
    price = T1 / T2 - T3;
  }

  return round(price, 3, Math.floor);
}

export function customDays360(start, end, basis = US_NASD) {
  return days360(moment(start).toDate(), moment(end).toDate(), basis);
}

export function getPeriodStart(settlement, maturity) {
  let periodStart = moment(maturity);
  periodStart.year(moment(settlement).year());
  while (periodStart.isAfter(settlement)) {
    periodStart.subtract(6, "month");
  }
  return periodStart;
}

export function round(num, dec, roundingFunction = null) {
  const places = Math.pow(10, dec);
  const rFunc = roundingFunction ?? Math.round;
  return rFunc((num + Number.EPSILON) * places) / places;
}
